import React from 'react';
import {colors} from "../styles/colors";
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack, resetNavigationToOverview} from "../navigation/NavigationActions";
import {connect} from "react-redux";
import {
    FacebookShareButton,
    WhatsappShareButton,
    EmailShareButton, FacebookIcon, WhatsappIcon, EmailIcon,
} from 'react-share';
import {saveHideShare, getHideShare} from "../utils/settingsStore";
import {ListItem} from "material-ui";
import {InfoOutline} from "material-ui-icons";
import {getUserSync} from "../utils/auth";
import Rater from 'react-rater'
import 'react-rater/lib/react-rater.css'
import MyButton from "../components/MyButton";
import './FeedbackScreen.css';
import Header from "../components/Header";
import i18n from 'i18next';

class FeedbackScreen extends React.PureComponent {


    constructor(props) {
        super(props);
        this.state = {
            showComment: false,
        };
    }


    handleChange = name => event => {
        this.setState({[name]: event.target.checked}, () => {
            saveHideShare(this.state.checkedA);
        });
    };

    componentDidMount() {
        let hideShare = getHideShare();
        this.setState({["checkedA"]: hideShare});
    }

    getShareUrl() {
        return 'https://toplife.zone/live/' + getUserSync()._id
    }

    onComment = () => {
        window.open(this.props.ad.link, '_blank');
    };

    getShareDescription(){
        const currentLanguage = i18n.language.split("-")[0] ? i18n.language.split("-")[0] : "en";
        if(currentLanguage === "de"){
            return this.props.ad.description_de
        }else{
            return this.props.ad.description_en
        }
    }

    getCtaText(){
        const currentLanguage = i18n.language.split("-")[0] ? i18n.language.split("-")[0] : "en";
        if(currentLanguage === "de"){
            return this.props.ad.cta_de
        }else{
            return this.props.ad.cta_en
        }
    }

    handleRate({ rating }) {
        if(rating >= this.props.ad.rating){
            this.setState({showComment: true});
        }else{
            this.props.goBackToOverview()
        }
    }
    render() {
        const {t} = this.props;

        return (
            <div className='feedbackWrapper'>
                    <Header
                        onBackPress={() => this.props.goBackToOverview()}
                        title={t('rating:title')}
                    />
                <div style={styles.shareContainer}>
                    <h1 style={styles.flex}>{t('rating:descriptionTitle')}</h1>

                    <div style={styles.share}>
                        <Rater total={5} rating={0} onRate={this.handleRate.bind(this)}/>
                    </div>

                    {this.state.showComment === true &&
                    <div style={styles.highlight}>
                        <p><strong>{t('rating:commentTitle')}</strong></p>
                        <p>{this.getShareDescription()}</p>
                        <p style={styles.thanks}><strong>{t('rating:commentUsThanks')}</strong></p>

                        <MyButton
                            title={this.getCtaText()}
                            variant="raised"
                            size="large"
                            color="primary"
                            fullWidth={true}
                            loading={false}
                            onPressButton={() => this.onComment()}/>

                    </div>}
                </div>
            </div>
        );
    }

}


const styles = ({
    shareContainer: {
        maxWidth: 512,
        margin: '0 auto',
        paddingTop: 72,
        paddingRight: 16,
        paddingLeft: 16,
    },
    flex: {
        flex: 1,
        color: colors.white
    },
    share: {
        marginTop: 16,
        marginBottom: 16,
    },
    highlight: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 16,
        backgroundColor: colors.white,
        boxShadow: `0 1px 3px 0 rgba(41,70,97,.2)`,
        borderRadius: 3,
    },
    icon: {
        marginRight: 16,
    },
    smLayout: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        outline: 'none'
    },
    smText: {
        paddingLeft: 16
    },
    smListButton: {
        paddingLeft: 16
    },
    smSkip: {
        paddingTop: 16,
        paddingBottom: 16,
        textDecoration: 'underline',
        cursor: 'pointer',
        textAlign: 'center',
        color: colors.text_light
    },
    hideShareLayout: {
        paddingTop: 32,
    },
    thanks: {
        paddingBottom: 16
    }
});

const mapStateToProps = (state) => {
    return {
        link: state.link,
        ad: state.ad,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        goBackToOverview: () => dispatch(resetNavigationToOverview()),
        goBack: () => dispatch(navigationBack())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate(['rating', 'friends', 'common'])(FeedbackScreen));


// WEBPACK FOOTER //
// ./src/feedback/FeedbackScreen.js